import { render } from "./Mail.vue?vue&type=template&id=5f93c938&scoped=true&bindings={}"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5f93c938"

export default script